import axios from 'axios';
import { ActionTree } from 'vuex';
import { RootState } from '@/store/types';
import {AccountFilter, AccountItem, AccountsState} from './types';
import {directDownload} from "@/utils/download-helper";

export const actions: ActionTree<AccountsState, RootState> ={
  getAccounts: ({commit, dispatch},data:AccountFilter) => {
    return new Promise((resolve, reject) => {
      axios({url: '/acapi/accounts',params: data})
        .then(resp => {
          if (data?.page_number > 1) {
            commit("pushAccounts", resp.data.accounts);
          } else {
            commit('setAccounts', resp.data.accounts);
          }
          resolve(resp.data.accounts)
        })
        .catch(err => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  getAccountItem: ({commit, dispatch},id) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({url: `/acapi/accounts/${id}`})
        .then((resp:any) => {
          let accountItem = <AccountItem>resp.data;
          accountItem.id = id;
          commit('setAccountItem', accountItem);
          resolve(accountItem)
        })
        .catch(err => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  saveAccount: ({commit, dispatch}, data:AccountItem) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: data.id ? 'put' : 'post',
// import { errorNotify } from '@/store/notify.ts';
        url: '/acapi/accounts/' + (data.id ?? ''),
        data: data
      })
        .then((resp:any) => {
          console.log(resp.data);
          dispatch('getAccounts');
          resolve(resp)
        })
        .catch((err:any) => {
          // errorNotify(err);
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  deleteAccount: ({commit, dispatch}, data:AccountItem) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: 'delete',
        url: `/acapi/accounts/${data.id}`,
        data: data
      })
        .then((resp:any) => {
          dispatch('getAccounts');
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  exportAccounts: ({commit, dispatch}, data: AccountFilter) => {
    return directDownload('acapi/accounts/export', data)
  },
};
